import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class isLoggedInGuard implements CanActivate {

  constructor(
    protected readonly router: Router,
    protected readonly auth: AuthService
  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.isLoggedIn) {
      if (this.auth.getAccount() == "AIRS") {
        return this.router.navigate(["/admin"]);
      } else if (this.auth.getAccount() == "MDA") {
        return this.router.navigate(["/mda"]);
      } else {
        return this.router.navigate(["/user"]);
      }
    }
    return true;
  }

}
